// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2BAdq","text":"SelectPayment_text___-Q21","title":"SelectPayment_title__1d5NL","btn":"SelectPayment_btn__1EeQv"};